import { environmentIdsSearchSchema } from '@routes/-environmentIdsSearch'
import { protectWithWorkspacePermissions } from '@routes/-protectWithPermission'
import { withCompanyName } from '@routes/-withCompanyName'
import { createFileRoute } from '@tanstack/react-router'
import { RequestFilteringPage } from 'features/requestFiltering'
import { canViewConfigurationPermission } from 'hooks/usePermission'

export const Route = createFileRoute('/_authenticated/_layout/workspaces/$subscriptionId/traffic-rules')({
  component: RequestFilteringPage,
  validateSearch: environmentIdsSearchSchema,
  head: () => ({
    meta: [
      {
        title: withCompanyName('Security'),
      },
    ],
  }),
  beforeLoad: protectWithWorkspacePermissions(canViewConfigurationPermission),
})
